<template>
  <div class="my-order">
    <div class="account-card">
      <!-- <div class="account-card-header">
        <p class="account-card-title">货款记录</p>
      </div> -->
      <!--搜索条件开始-->
      <el-form
        size="mini"
        class="order-form"
        :inline="true"
        :model="form"
        ref="ruleForm"
        label-width="110px"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="公告编号："
              prop="noticeCode"
            >
              <el-input
                v-model="form.noticeCode"
                autocomplete="off"
                placeholder="请输入公告编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="公告标题："
              prop="noticeTitle"
            >
              <el-input
                v-model="form.noticeTitle"
                autocomplete="off"
                placeholder="请输入公告标题"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              prop="orderType"
              label="操作事项："
            >
              <el-select v-model="form.orderType" placeholder="请选择操作事项">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="操作日期开始："
              prop="sendTimeStart"
            >
              <el-date-picker
                style="width: 100%;"
                v-model="form.sendTimeStart"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="请选择开始日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="操作日期结束："
              prop="sendTimeEnd"
            >
              <el-date-picker
                style="width: 100%;"
                v-model="form.sendTimeEnd"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button size="mini" type="primary" @click="onSubmit"
                >搜索</el-button
              >
              <el-button size="mini" type="plain" @click="resetForm('ruleForm')"
                >清空</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!--搜索条件结束-->
    </div>
    <!--结果表格开始-->
    <div class="my-order-body">
      <el-table :data="tableData" fit border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          label="公告编号"
          width="140"
          header-align="center"
          align="center"
          prop="noticeCode"
        >
        </el-table-column>
        <el-table-column
          label="公告标题"
          show-overflow-tooltip
          header-align="center"
          prop="noticeTitle"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="orderType"
          label="操作事项"
          width="100"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ checkOrderType(scope.row.orderType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="交易金额（元）"
          width="130"
          header-align="center"
          align="right"
        ></el-table-column>
        <!-- <el-table-column
          prop="runningNumber"
          label="支付流水号"
          width="200"
          header-align="center"
          align="center"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          prop="sendTime"
          label="操作时间"
          width="150"
          show-overflow-tooltip
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="statusCode"
          label="状态"
          width="120"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ checkStatusCode(scope.row.statusCode) }}
          </template></el-table-column
        >
      </el-table>
      <el-row class="notice-pagination">
        <el-col :offset="7" :span="12">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout=" pager, next,total, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pagination.pageIndex"
            :total="pagination.total"
          >
            到第{{ pagination.pageIndex }}页
          </el-pagination>
        </el-col>
      </el-row>
    </div>
    <!--结果表格结束-->
  </div>
</template>

<script>
export default {
  components: {},
  directives: {},
  filters: {},
  mixins: {},
  props: {
    typeForm: String
  },
  data() {
    return {
      form: {
        noticeCode: null,
        noticeTitle: null,
        sendTimeStart: null,
        sendTimeEnd: null,
        orderType: null
      },
      tableData: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      options: [
        {
          label: '冻结货款',
          value: 11
        },
        {
          label: '确认收货',
          value: 12
        },
        {
          label: '解冻货款',
          value: 13
        }
      ],
      options1: [
        {
          label: '支付保证金',
          value: 1
        },
        {
          label: '解冻保证金',
          value: 2
        },
        {
          label: '补交保证金',
          value: 3
        },
        {
          label: '扣除服务费',
          value: 4
        },
        {
          label: '补交服务费',
          value: 5
        },
        {
          label: '罚没保证金',
          value: 6
        },
        {
          label: '冻结货款',
          value: 11
        },
        {
          label: '确认收货',
          value: 12
        },
        {
          label: '解冻货款',
          value: 13
        },
        {
          label: '预付服务费',
          value: 21
        },
        {
          label: '解冻预付服务费',
          value: 22
        },
        {
          label: '补交预付服务费',
          value: 23
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    let params = {
      pageSize: this.pagination.pageSize,
      pageIndex: this.pagination.pageIndex
    }
    this.getTableData(params)
    if (!this.typeForm) {
      this.options = this.options1
    }
  },
  methods: {
    checkOrderType(type) {
      if (type == 1) {
        return '支付保证金'
      } else if (type == 2) {
        return '解冻保证金'
      } else if (type == 3) {
        return '补交保证金'
      } else if (type == 4) {
        return '扣除服务费'
      } else if (type == 5) {
        return '补交服务费'
      } else if (type == 6) {
        return '罚没保证金'
      } else if (type == 11) {
        return '冻结货款'
      } else if (type == 12) {
        return '确认收货'
      } else if (type == 13) {
        return '解冻货款'
      } else if (type == 21) {
        return '预付服务费'
      } else if (type == 22) {
        return '解冻预付服务费'
      } else if (type == 23) {
        return '补交预付服务费'
      }
    },
    checkStatusCode(type) {
      if (type == 0) {
        return '接口调用失败'
      } else if (type == 1) {
        return '已发起支付'
      } else if (type == 10) {
        return '支付成功'
      } else if (type == 11) {
        return '支付失败'
      }
    },
    async getTableData(params) {
      let data
      if (this.typeForm == 'myDepositLoanseller') {
        data = await this.$api.depositPrice.listRecordseller(params)
      } else {
        data = await this.$api.depositPrice.listRecord(params)
      }

      this.pagination.total = data.total || 0
      this.tableData = data.data || []
    },
    // toDetail(row) {
    //   let path = '/home/account/orderDetail'
    //   let id = row.row.id
    //   this.$router.push({
    //     path,
    //     query: {
    //       id
    //     }
    //   })
    // },
    //点击搜索
    onSubmit() {
      // Object.keys(this.form).forEach(item => {
      //   if (!this.form[item]) delete this.form[item]
      // })
      this.pagination.pageIndex = 1
      let param = { ...this.form, pageIndex: 1, pageSize: 10 }
      this.getTableData(param)
    },
    //点击清空
    resetForm(formName) {
      this.pagination.pageIndex = 1
      let params = {
        pageSize: this.pagination.pageSize,
        pageIndex: this.pagination.pageIndex
      }
      this.getTableData(params)
      this.$refs[formName].resetFields()
    },
    handleSizeChange(val) {
      // Object.keys(this.form).forEach(item => {
      //   if (!this.form[item]) delete this.form[item]
      // })
      this.pagination.pageIndex = 1
      let param = { ...this.form, pageIndex: 1, pageSize: val }
      this.getTableData(param)
    },
    handleCurrentChange(val) {
      // Object.keys(this.form).forEach(item => {
      //   if (!this.form[item]) delete this.form[item]
      // })
      this.pagination.pageIndex = val
      let param = { ...this.form, pageIndex: val, pageSize: 10 }
      this.getTableData(param)
    }
    // onOperation(row) {
    //   this.$router.push('/myDepositOperate', {orderType: row.orderType})
    // }
  }
}
</script>
<style lang="less" scoped>
.my-order {
  margin-bottom: 30px;
  .account-card {
    .order-form {
      // padding: 15px 34px;
      .el-form-item.el-form-item--mini {
        display: flex !important;
        width: 95%;
      }
      .el-button {
        font-size: 15px;
        padding: 8px 15px;
      }
    }
  }
}
</style>
